<!--  -->
<template>
  <div>
      <section class="course-area">
        <div class="container course-wrapper">
            <div class="">
                <div class="row">
                  <div class="section-heading">   
                      <h2 class="section__title"><span>课程学习</span></h2> 
                      <span>经典课程推荐，帮助您就业，考完即拿证书</span>
                  </div><!-- end section-heading -->
                </div><!-- end row -->
                <div class="fenl row">
                    <div class="col-lg-12">
                        <div class="clickleft" @click="changeBtn('left')">

                        </div>
                        <div class="course-tab-wrap">
                            <ul ref="tablist" class="course-tab-list" role="tablist" :style="`width:${(courcates.length+1)*180}px;`" id="review">
                                <li>
                                    <a @click="chgcourcate('全部课程')" role="tab" data-toggle="tab" :class="catesel == '全部课程' ? 'active' : ''" aria-selected="true">
                                      全部课程
                                    </a>
                                </li>
                                <li role="presentation" v-for="(courcate,index) in courcates" :key="index">
                                    <a @click="chgcourcate(courcate.name)" role="tab" data-toggle="tab" :class="catesel==courcate.name?'active':''" aria-selected="true">
                                        {{courcate.name}}
                                    </a>
                                </li>
                            </ul>
                        </div>
                        <div class="clickright" @click="changeBtn('right')">

                        </div>
                    </div><!-- end col-lg-12 -->
                </div><!-- end row -->
            </div><!-- end container -->
        </div><!-- end course-wrapper -->
       
        <div class="course-content-wrapper">
            <div class="container">
                 <div class="course-line"></div>
                <div class="row course-item-wrap">
                    <div class="col-lg-12">
                        <div class="tab-content">
                            <div role="tabpanel" class="tab-pane fade show active" id="tab1">
                                <div class="row course-block">
                                    <div class="col-lg-3" v-for="(course,index) in courses" :key="index">
                                        <div class="course-item" @click="$router.push(`/courview/info/${course._id}`)">
                                            <div class="course-img">
                                                <router-link :to="`/courview/info/${course._id}`" class="course__img"><img :src="`${global.remoteIp}/uploads/${course.picsrc}`" alt=""></router-link>
                                                <div class="course-tooltip">
                                                    <span v-if="course.spltip" class="tooltip-label">{{course.spltip}}</span>
                                                </div>
                                            </div><!-- end course-img -->
                                            <div class="course-content">
                                                <h3 class="course__title">
                                                    {{course.title}}
                                                </h3>
                                                <div class="rating-wrap" v-if="course.stars">{{ parseFloat(course.stars).toFixed(1) }}分</div>
                                                <div class="rating-wrap" v-else>5.0分</div>
                                                <span class="course-meta">{{ course.totalClass }}人学习</span>
                                            </div><!-- end course-content -->
                                        </div><!-- end course-item -->
                                    </div><!-- end col-lg-4 -->
                                     <div class="col-lg-3" v-for="(course, index) in courses" :key="index">
                                          <div class="course-item" @click="$router.push(`/courview/info/${course._id}`)">
                                              <div class="course-img">
                                                  <router-link :to="`/courview/info/${course._id}`" class="course__img"><img :src="`${global.remoteIp}/uploads/${course.picsrc}`" alt=""></router-link>
                                                  <div class="course-tooltip">
                                                      <span v-if="course.spltip" class="tooltip-label">{{ course.spltip }}</span>
                                                  </div>
                                              </div><!-- end course-img -->
                                              <div class="course-content">
                                                  <h3 class="course__title">
                                                      {{ course.title }}
                                                  </h3>
                                                  <div class="rating-wrap" v-if="course.stars">{{ parseFloat(course.stars).toFixed(1) }}分</div>
                                                  <div class="rating-wrap" v-else>5.0分</div>
                                                  <span class="course-meta">{{ course.totalClass }}人学习</span>
                                              </div><!-- end course-content -->
                                          </div><!-- end course-item -->
                                      </div><!-- end col-lg-4 -->
                                       <div class="col-lg-3" v-for="(course, index) in courses" :key="index">
                                          <div class="course-item" @click="$router.push(`/courview/info/${course._id}`)">
                                              <div class="course-img">
                                                  <router-link :to="`/courview/info/${course._id}`" class="course__img"><img :src="`${global.remoteIp}/uploads/${course.picsrc}`" alt=""></router-link>
                                                  <div class="course-tooltip">
                                                      <span v-if="course.spltip" class="tooltip-label">{{ course.spltip }}</span>
                                                  </div>
                                              </div><!-- end course-img -->
                                              <div class="course-content">
                                                  <h3 class="course__title">
                                                      {{ course.title }}
                                                  </h3>
                                                  <div class="rating-wrap" v-if="course.stars">{{ parseFloat(course.stars).toFixed(1) }}分</div>
                                                  <div class="rating-wrap" v-else>5.0分</div>
                                                  <span class="course-meta">{{ course.totalClass }}人学习</span>
                                              </div><!-- end course-content -->
                                          </div><!-- end course-item -->
                                      </div><!-- end col-lg-4 -->
                                </div><!-- end course-block -->
                            </div><!-- end tab-pane -->
                        </div><!-- end tab-content -->
                    </div><!-- end col-lg-12 -->
                </div><!-- end row -->
            </div><!-- end container -->
        </div><!-- end course-content-wrapper -->
        <div class="container">
            <div class="align-items-center">
                <router-link class="theme-btn" to="/courviews">MORE</router-link>
            </div><!-- end button-shared-->
        </div><!-- end col-lg-3 -->
    </section>
  </div>
</template>

<script>
import global from "@/components/PublicComs/Common.vue";
export default {
  data() {
    return {
      catesel: "全部课程",
      courcates: [
          "评分最高",
          "最受欢迎",
          "销量最高"
      ],
      changeindex: 0,
      tabwidth:0,
      courses: [],
      global,
    };
  },

  components: {},

  computed: {},

  mounted() {
    this.$axios
      .get("/api/bigCourseTypes?page=1&limit=12&sort=-createdAt")
      .then((res) => {
        if (res.data) {
          this.courcates = res.data.data;
          this.tabwidth = (this.courcates.length) * 180-6*180;
        }
      });
    this.$axios
      .get("/api/courses/visitor?page=1&limit=8&sort=-istop,-createdAt")
      .then((res) => {
        if (res.data) {
          this.courses = res.data.data;
        }
      });
  },

  methods: {
    chgcourcate(cate) {
      this.catesel = cate;
      var searchConditions = "";
      if (this.catesel !="全部课程") {
        searchConditions += "&type=" + this.catesel;
      }
      this.$axios
        .get(
          `/api/courses/visitor?page=1&limit=8${searchConditions}`
        ).then((res) => {
          if (res.data) {
            this.courses = res.data.data;
          }
        });
    },
    changeBtn(index) {
      let temp = this.changeindex * 180;
      if (index == 'left') {
        if (temp > 0) {
          this.changeindex = this.changeindex - 1;
          this.$refs.tablist.style.left = '-' + 180 * this.changeindex + 'px';
        }
      } else {
        console.log(this.changeindex);
        if (temp <= this.tabwidth) {
          this.changeindex = this.changeindex + 1;
          this.$refs.tablist.style.left = '-' + 180* this.changeindex + 'px';
        }
      }
      
    }
  },
};
</script>
<style scoped>
.el-icon-video-play{
    font-weight: bold;
}
.el-icon-time{
    font-weight: bold;
}
.category-area{
	margin-top: 68px;
}
.course-area{
  background: #F9F9F9;
  padding-bottom: 20px;
  background-image: url(/static/img/quanquanbeijgin.png);
  background-size: 1822px auto;
  background-position: center bottom;
  background-repeat: no-repeat;
}
.course__label-text{
    margin-left: 23px;
}
#review li a{
float: left;
width: 159px;
height: 49px;
background: #F1F3FA;
border-radius: 25px;
font-size: 18px;
font-family: PingFang SC;
font-weight: 500;
color: #666666;
line-height: 49px;
text-align: center;
  overflow: hidden;
}
#review li a.active{
background: #4462CF;
color: #FFFFFF;
}
.course-tab-wrap{
  position: relative;
  width: 1060px;
  height: 49px;
  margin: 0 70px 34px;
  overflow: hidden;
  margin-top: 0;
}
#review{
  overflow: hidden;
   position: absolute;
   top:0;
   left: 0;
}
#review li{
  cursor: pointer;
float: left;
width: 159px;
height: 49px;
margin-right: 21px;
}
.col-lg-12{
  position: relative;
}
.clickleft{
  position: absolute;
  cursor: pointer;
  top:0;
  left:15px;
  width: 40px;
height: 49px;
background-image: url(/static/img/zuohua.png);
background-repeat: no-repeat;
background-size: 40px 40px;
background-position: 0 center;
}
.clickright{
  position: absolute;
  cursor: pointer;
   top:0;
  right:15px;
  width: 40px;
height: 49px;
background-image: url(/static/img/youhua.png);
background-repeat: no-repeat;
background-size: 40px 40px;
background-position: right center;
}
/* col-lg-3 */
.course-item{
  width: 278px;
height: 308px;
overflow: hidden;
display: flex;
flex-direction: column;
justify-content: start;
background: #FEFEFE;
box-shadow: 0px 0px 24px 0px rgba(211,211,225,0.58);
border-radius: 10px;
}
.course-img img{
width: 278px;
height: 207px;
background: #FEFEFE;
}
.course-content{
  position: relative;
  margin-top: 17px;
  width: 278px;
height: 101px;
border:0;
background: #FEFEFE;
}
.course__title{
  margin-top: 0;
  margin-bottom: 8px;
  padding-left: 12px;
width: 190px;
height: 18px;
font-size: 18px;
font-family: PingFang SC;
font-weight: bold;
color: #333333;
line-height: 18px;
 -webkit-background-clip: text;
  word-break: break-all;
  -webkit-box-orient: vertical;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  -webkit-line-clamp: 1;
}
.rating-wrap{
  position: absolute;
  top:0;
  right: 15px;
  width: 48px;
height: 18px;
font-size: 18px;
font-family: PingFang SC;
font-weight: bold;
color: #F55C57;
line-height: 18px;
}
.course-meta{
margin-left: 12px;
padding: 0 10px;
height: 28px;
background: #F6F6F6;
border-radius: 3px;
font-size: 14px;
font-family: PingFang SC;
font-weight: 500;
color: #666666;
}

</style>
